var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.maxspace ? 'col-xl-3' : '', 'capability col-md-4 col-6']},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.capability.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }